export const UPDATE_CLICKED = "UPDATE_CLICKED";
export const FLIP_ALL = "FLIP_ALL";
export const FLIP_ALL_UNCLICKED = "FLIP_ALL_UNCLICEKD";
export const FLIP_COLUMN = "FLIP_COLUMN";
export const UPDATE_CURRENT_TILE = "UPDATE_CURRENT_TILE";
export const UPDATE_MEMOS = "UPDATE_MEMOS";
export const UPDATE_ROUND_SCORE = "UPDATE_ROUND_SCORE";
export const UPDATE_TOTAL_SCORE = "UPDATE_TOTAL_SCORE";
export const TOGGLE_MENU = "TOGGLE_MENU";
export const UPDATE_GRID = "UDPATE_GRID";
export const RESET_GRID = "RESET_GRID";
export const CHANGE_VIEW = "CHANGE_VIEW";
export const UPDATE_LEVEL = "UPDATELEVEL";

//end of round stuff
export const CLOSE_DIALOGUE_BOX = "CLOSE_DIALOGUE_BOX";
export const RESET_ROUND_SCORE = "RESET_ROUND_SCORE";
export const OPEN_DIALOGUE_BOX = "OPENDIALGOUE";
export const TOGGLE_ROUND_INTERMISSION = "toggleroundinterm";
export const SET_ROUND_LOSS = "SEtRoundLoss";
export const SET_CLICKS = "SET_CLICKS";
export const CHANGE_DIALOGUE_TEXT = "CHANGE_DIALOGUE_TEXT";
